
import { Link } from "react-router-dom"
import styles from "./not-found.module.css"
import { useTheme } from "@/components/context/ThemeContext"

export default function NotFound() {
  const {theme} = useTheme()
  return (
    <div className={`${styles.container} ${theme==="dark" ? "dark" : ""}`}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <path d="M12 7V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        <h1 className={styles.title}>Tournament Not Found</h1>

        <p className={styles.description}>
          The tournament you're looking for doesn't exist or has been removed. Try browsing our available tournaments!
        </p>

        <div className={styles.actions}>
          <Link to="/tournament/dashboard" className={styles.primaryButton}>
            <span>Browse All Tournaments</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  )
}
